import { Fragment, useCallback } from "react";
import "./ListingHeader.scss";
import { merchandisingShape, productShape, resolutionPropType } from "app/utils/propTypes";
import { sendTagOnMerchandisingViewedOnListing } from "app/utils/analytics";
import { FormattedMessage, FormattedPlural } from "react-intl";
import PropTypes from "prop-types";
import Jumbotron from "app/pages/Listing/Product/Jumbotron";
import ListingActionbar from "app/pages/.shared/ListingActionbar/ListingActionbar";
import ListingHero from "@brand/Listing/ListingHero/ListingHero";
import NavLogsContainer from "app/pages/Listing/NavLogs/NavLogsContainer";
import { Waypoint } from "react-waypoint";
import isEmpty from "lodash/isEmpty";
import SmartDPImmersiveSearch from "app/pages/SmartDP/Search/SmartDPImmersiveSearch/SmartDPImmersiveSearch";

const waypointScrollableAncestor = typeof window !== "undefined" ? window : undefined;

const ListingHeader = ({
	heroProduct,
	resolution,
	merchandisingHeader = [],
	isListViewDisplay,
	toogleCardView,
	toogleListView,
	products = [],
	listingHeaderRef,
	shouldFetchNavlogs,
	displayProductsCount,
	partnerCode,
	enableAtol,
	marketingBanner,
	showPfsMessage,
	partnerListingHero = {},
}) => {
	const sendTagMerchHeader = useCallback(() => {
		const merch = merchandisingHeader[0];

		if (merch) {
			sendTagOnMerchandisingViewedOnListing(merch.code, merch.label, merch.position);
		}
	}, [merchandisingHeader]);

	const {
		heroTitleMobile,
		heroTitleDesktop,
		heroSubtitleMobile,
		heroSubtitleDesktop,
		heroImageMobile,
		heroImageDesktop,
		heroImageMobileThumbnail,
		heroImageDesktopThumbnail,
	} = partnerListingHero;

	let header = "";
	if (heroProduct) {
		header = (
			<div className="listing-header__hero-product" data-testid="listing-header-hero-product">
				<Jumbotron product={heroProduct} />
			</div>
		);
	} else if (!isEmpty(partnerListingHero)) {
		header = (
			<SmartDPImmersiveSearch
				heroTitleDesktop={heroTitleDesktop}
				heroTitleMobile={heroTitleMobile}
				heroSubtitleDesktop={heroSubtitleDesktop}
				heroSubtitleMobile={heroSubtitleMobile}
				heroTextAlign="left"
				heroImageMobile={heroImageMobile}
				heroImageDesktop={heroImageDesktop}
				heroImageMobileThumbnail={heroImageMobileThumbnail}
				heroImageDesktopThumbnail={heroImageDesktopThumbnail}
				hideSmartDPForm={true}
			/>
		);
	} else {
		header = (
			<Fragment>
				<Waypoint
					scrollableAncestor={waypointScrollableAncestor}
					onEnter={sendTagMerchHeader}
				/>
				<ListingHero
					marketingBanner={marketingBanner}
					merchList={merchandisingHeader}
					partnerCode={partnerCode}
					resolution={resolution}
				/>
			</Fragment>
		);
	}

	return (
		<div className="listing-header">
			{header}

			<div className="listing-header__action-section">
				{shouldFetchNavlogs && (
					<div className="listing-header__navlogs">
						<NavLogsContainer />
					</div>
				)}

				<div ref={listingHeaderRef}>
					<ListingActionbar
						label={
							/**
							 * On affiche le nombre de produits dans le cas où
							 * il n'y a pas assez de produits à cause des filtres
							 * On n'affiche pas le compteur à 4 (SSR qui ne récupère que les 4 premier produits)
							 */
							displayProductsCount && (
								<div data-testid="listing-actionbar-current-count">
									<span className="listing-actionbar__current-count">
										{products.length}
									</span>
									<FormattedPlural
										value={products.length}
										one={
											<FormattedMessage id="listing.products.current.count.singular" />
										}
										other={
											<FormattedMessage id="listing.products.current.count.plural" />
										}
									/>
								</div>
							)
						}
						listViewDisplay={isListViewDisplay}
						onCardButtonClick={toogleCardView}
						onListButtonClick={toogleListView}
						enableAtol={enableAtol}
						showPfsMessage={showPfsMessage}
					/>
				</div>
			</div>
		</div>
	);
};

ListingHeader.propTypes = {
	heroProduct: productShape,
	isListViewDisplay: PropTypes.bool,
	enableAtol: PropTypes.bool,
	resolution: resolutionPropType,
	merchandisingHeader: PropTypes.arrayOf(merchandisingShape),
	toogleCardView: PropTypes.func,
	toogleListView: PropTypes.func,
	products: PropTypes.arrayOf(productShape),
	// en react.16 createRef renvoit un object dont la prop current est populate par l'élément du DOM (et non une fonction comme sur les anciennes versions)
	listingHeaderRef: PropTypes.object,
	partnerCode: PropTypes.string,
	shouldFetchNavlogs: PropTypes.bool,
	displayProductsCount: PropTypes.bool,
	showPfsMessage: PropTypes.bool,
	marketingBanner: PropTypes.object,
	partnerListingHero: PropTypes.object,
};

export default ListingHeader;
